import axios from 'axios';
import type { AxiosInstance, AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';

/**
 * Client HTTP preconfigurato per comunicare con il backend V-Spot.
 * Base URL configurato tramite proxy di Vite in sviluppo.
 */
const client: AxiosInstance = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor per la richiesta: aggiunge eventuale token di autenticazione
client.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('vspot_token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Interceptor per la risposta: gestione centralizzata degli errori
client.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Token scaduto o non valido: rimuovi e ricarica (opzionale nell'MVP)
      localStorage.removeItem('vspot_token');
      console.warn('Sessione scaduta. Effettua nuovamente il login.');
    }
    return Promise.reject(error);
  }
);

export default client;